<template>
	<el-container class="min-width">
		<el-header>{{ unitName }}</el-header>
	<div class="agreement">
		<div class="main">
		<p class="time">当前时间：{{ nowDate }}</p>
			<div class="instruction" style="font-size:24px">
				<p>提示：<span style="color: #1a222e">推荐使用</span>360浏览器、QQ浏览器、谷歌浏览器、搜狗浏览器</p><br>
				<p>请务必使用浏览器的<span style="font-weight: bold">极速模式</span>访问本系统</p>
			</div>
			<div class="footer-btns">
				<el-button v-if=" isRegist || isTest " class="btn2" type="primary" round size="large" @click="goRegister">
					立即报名
				</el-button>
			</div>
			<div class="footer-btns">
				<el-button class="btn3" type="warning" size="large" round @click="handleSearch()">登录查询</el-button>
			</div>
			<div class="footer-btns">
				<el-button class="btn4" plain size="large" round @click="
						() => {
							$router.push('/agreement');
						}
					">
					返回上一页
				</el-button>
			</div>
		</div>
	</div>
	<div class="copyright"><a style="text-decoration: none; color:black" target="_blank" href="https://beian.miit.gov.cn/ ">渝ICP备2024041183号-1</a></div>
	</el-container>
</template>

<script>
import { reqRegistOpen } from '@/api';
	import {
		mapState
	} from 'vuex';
	export default {
		data() {
			return {
				nowDate: '', // 当前日期
				isRegist: false,
			};
		},
		computed: {
			...mapState({
				unitName: state => state.system.unitName,
				examination_id: state => state.system.examInfo.examination_id,
				unitCode: state => state.system.unitCode,
				company_id: state => state.system.company_id,
				mobile: state => state.system.mobile,
				refresh: state => state.system.refresh,
				examInfo: state => state.system.examInfo,
				payment: state => state.system.payment,
				time_out: state => state.system.time_out,
			}),
			isTest() {
				return sessionStorage.getItem('test') || false;
			},
		},
		methods: {
		      goRegister() {
				this.$router.push('/form');
		      },
			currentTime() {
				setInterval(this.formatDate, 500);
			},
			formatDate() {
				let date = new Date();
				let year = date.getFullYear(); // 年
				let month = date.getMonth() + 1; // 月
				month = month < 10 ? '0' + month : month;
				let day = date.getDate(); // 日
				day = day < 10 ? '0' + day : day;
				let week = date.getDay(); // 星期
				let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
				let hour = date.getHours(); // 时
				hour = hour < 10 ? '0' + hour : hour; // 如果只有一位，则前面补零
				let minute = date.getMinutes(); // 分
				minute = minute < 10 ? '0' + minute : minute; // 如果只有一位，则前面补零
				let second = date.getSeconds(); // 秒
				second = second < 10 ? '0' + second : second; // 如果只有一位，则前面补零
				this.nowDate = `${year}-${month}-${day} ${hour}:${minute}:${second} ${weekArr[week]}`;
			},
			handleSearch() {
				this.$router.push('/search');
			},
			getRegistOpen() {
				reqRegistOpen({
					id: this.examination_id
				}).then(res => {
					this.isRegist = res.data;
				}).catch((error => {
					console.log(error);
				}));
			}
		},
		mounted() {
			this.currentTime();
			this.getRegistOpen();
		},
		// 销毁定时器
		beforeDestroy() {
			if (this.formatDate) {
				clearInterval(this.formatDate); // 在Vue实例销毁前，清除时间定时器
			}
		}
	};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';

.min-width {
	min-width: 1200px;
}
.copyright {
	position: fixed;
	bottom: 5px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 14px;
}

.el-header {
	background-color: $--color-primary;
	box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.04);
	font-size: 28px;
	color: #ffffff;
	line-height: 60px;
	padding-left: 80px;
}
	.agreement {
		padding: 0 120px;
		margin-top:12%;

		.time {
			position: absolute;
			top: 7%;
			right: 5%;
			font-size: 14px;
			color: #1a222e;
		}

		.main {
			background: #ffffff;
			box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.16);
			color: #3a3a3a;
			padding: 40px 60px;

			.instruction {
				padding-top: 15px;
				display: flex;
				align-items: center;
				overflow-x: hidden;
				overflow-y: auto;
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 50px 0;
					
				> p {
					color:#FF0000;
				}
			}

		}
	}
</style>
